/**
 * Module workers under Trusted Types. The page's CSP is `require-trusted-types-for 'script'; trusted-types
 * provenance-worker`, and `new Worker(url)` is a Trusted Types sink in every engine, so every worker URL goes through the one
 * policy this app creates. It accepts only a same-origin script URL and throws on anything else (SECURITY §7.2, UD-9). The
 * analysis worker and the bench worker (BENCH-V2-SPEC §12.4) share it: a policy name can be created once.
 */
interface TTPolicy {
	createScriptURL(input: string): unknown;
}
interface TTFactory {
	createPolicy(name: string, rules: { createScriptURL: (input: string) => string }): TTPolicy;
}

const SCRIPT_PATH = /^\/(?:assets\/)?[\w@./~-]+\.(?:m?js|ts)$/;

let policy: TTPolicy | null | undefined;

export function trustedScriptUrl(url: string): string | unknown {
	if (policy === undefined) {
		const tt = (globalThis as unknown as { trustedTypes?: TTFactory }).trustedTypes;
		policy = tt
			? tt.createPolicy('provenance-worker', {
					createScriptURL: (input: string) => {
						const u = new URL(input, location.href);
						if (u.origin !== location.origin || !SCRIPT_PATH.test(u.pathname))
							throw new TypeError('provenance-worker: not a same-origin script URL');
						return u.href;
					},
				})
			: null;
	}
	return policy ? policy.createScriptURL(url) : url;
}

export function spawnWorker(url: string, name: string): Worker {
	return new Worker(trustedScriptUrl(url) as string, { type: 'module', name });
}
